import { render, staticRenderFns } from "./ConversationMessage.vue?vue&type=template&id=46803d66&scoped=true&"
import script from "./ConversationMessage.vue?vue&type=script&lang=js&"
export * from "./ConversationMessage.vue?vue&type=script&lang=js&"
import style0 from "./ConversationMessage.vue?vue&type=style&index=0&id=46803d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46803d66",
  null
  
)

export default component.exports